import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem, Select, TextField } from '@mui/material';
import { Modal, Typography } from "@mui/material";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '@mui/material';
import { Box } from '@mui/material';
import { FormControl } from '@mui/material';
import { InputLabel } from '@mui/material';
import { Stack } from '@mui/material';
import APIManager from '../../../../lib/apiManager';

const NuevoModal = ({ open, setOpen, selectedItem, columns, setSelectedItem }) => {
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');

  const navigate = useNavigate();

  const handleContinuar = () => {
    const nuevoItem = Object.assign({}, selectedItem, { nombre: nombre, descripcion: descripcion });
    setSelectedItem(nuevoItem);
    setOpen(false);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleCancel = () => {
    handleClose();
  }

  const handleChangeNombre = (event) => {
    setNombre(event.target.value);
  }

  const handleChangeDescripcion = (event) => {
    setDescripcion(event.target.value);
  }

  useEffect(() => {
    setNombre(selectedItem?.nombre ?? '');
    setDescripcion(selectedItem?.descripcion ?? '');
  }, [selectedItem]);

  return (
    <Dialog
    open={open}
    aria-labelledby="nuevoContrato-dialog-title"
    aria-describedby="nuevoContrato-dialog-description"
  >
      <DialogTitle id="alert-dialog-title">
        Agrupacion de Rubros / Profesiones
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="nuevoContrato-dialog-description">
           Ingrese los datos
        </DialogContentText>
        <Stack spacing={2} marginTop={2}>
          <TextField variant="standard" fullWidth
            label="Nombre"
            value={nombre}
            onChange={handleChangeNombre}
          />
          <TextField variant="standard" fullWidth
            label="Descripcion"
            value={descripcion}
            onChange={handleChangeDescripcion}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancelar</Button>
        <Button onClick={handleContinuar} disabled={!nombre}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NuevoModal;